import Cookies from 'js-cookie'

const SidebarKey = 'sidebarStatus'
const LanguageKey = 'language'
const TransLangKey = 'transLang'
const RememberKey = 'rememberStatus'
const UsernameKey = 'rememberUsername'

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get(SidebarKey),
      withoutAnimation: false
    },
    device: 'desktop',
    referer: null,
    preferer: null,
    language: Cookies.get(LanguageKey),
    translang: Cookies.get(TransLangKey),
    remember: (Cookies.get(RememberKey) === 'true'),
    username: Cookies.get(UsernameKey)
  },
  mutations: {
    SET_REFERER: (state, path) => {
      state.referer = path
    },
    SET_PREFERER: (state, path) => {
      state.preferer = path
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set(SidebarKey, 1)
      } else {
        Cookies.set(SidebarKey, 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set(SidebarKey, 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set(LanguageKey, language)
    },
    SET_TRANSLANG: (state, lang) => {
      state.translang = lang
      Cookies.set(TransLangKey, lang)
    },
    SET_REMEMBER: (state, value) => {
      state.remember = value
      if (state.remember) {
        Cookies.set(RememberKey, 'true')
      } else {
        Cookies.remove(RememberKey)
      }
    },
    SET_USERNAME: (state, value) => {
      state.username = value
      if (state.username === '') {
        Cookies.remove(UsernameKey)
      } else {
        Cookies.set(UsernameKey, value)
      }
    }
  },
  actions: {
    toggleSideBar ({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar ({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice ({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage ({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setReferer ({ commit }, path) {
      commit('SET_REFERER', path)
    },
    setPReferer ({ commit }, path) {
      commit('SET_PREFERER', path)
    },
    setTransLang ({ commit }, lang) {
      commit('SET_TRANSLANG', lang)
    },
    setRemember ({ commit }, value) {
      commit('SET_REMEMBER', value)
    },
    setUsername ({ commit }, value) {
      commit('SET_USERNAME', value)
    }
  }
}

export default app
